import React from "react";

export default function RainbowButton({
  text,
  href,
  newTab = true,
  type = "button",
}) {
  const target = newTab ? "_blank" : "_self";
  return (
    <a href={href} target={target} rel="noopener noreferrer">
      <button className="glow-on-hover" type={type}>
        {text}
      </button>
    </a>
  );
}
